export default "__VITE_ASSET__Cu1s48Rm__"